import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthInterceptorService implements HttpInterceptor {

  constructor() {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = localStorage.getItem('token');
    let request = req;
    const ipApiUrl = 'https://api.ipify.org';
    if (req.url.includes(ipApiUrl)) {
      const modifiedReq = req.clone({
        headers: req.headers.delete('Authorization')
      });
      return next.handle(modifiedReq);
    } else {
      if (token) {
        request = req.clone({
          setHeaders: {
            authorization: `Bearer ${token}`
          }
        });
      }
      return next.handle(request);
    }
  }
}
